import { Layout } from '../components/Layout';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

export const TermsOfServicePage = () => {
  return (
    <Layout>
      <div className="section-spacing" data-testid="terms-of-service-page">
        <div className="container-luxury max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="text-center mb-12">
              <FileText className="h-12 w-12 text-[#C6A87C] mx-auto mb-4" />
              <h1 className="font-heading text-3xl md:text-4xl text-[#2C2420] mb-4">
                Terms of Service
              </h1>
              <p className="text-[#5D5550]">Last updated: February 2025</p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">1. Overview</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  This website is operated by Shiva Shakti Garments. Throughout the site, the terms "we", "us" and "our" refer to Shiva Shakti Garments. By visiting our site and/or purchasing something from us, you engage in our "Service" and agree to be bound by the following terms and conditions.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">2. Online Store Terms</h2>
                <p className="text-[#5D5550] leading-relaxed mb-4">
                  By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, and you have given us your consent to allow any of your minor dependents to use this site.
                </p>
                <p className="text-[#5D5550] leading-relaxed">
                  You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">3. Products and Pricing</h2>
                <p className="text-[#5D5550] leading-relaxed mb-4">
                  All prices are displayed in Euros (€) and include applicable taxes. We reserve the right to modify prices at any time without prior notice.
                </p>
                <p className="text-[#5D5550] leading-relaxed">
                  We have made every effort to display as accurately as possible the colors and images of our products. We cannot guarantee that your computer monitor's display of any color will be accurate.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">4. Returns and Refunds</h2>
                <p className="text-[#5D5550] leading-relaxed mb-4">
                  We offer a 30-day return policy on all unworn items in their original condition with tags attached. To initiate a return, please contact us at prabalbansal11@gmail.com.
                </p>
                <p className="text-[#5D5550] leading-relaxed">
                  Refunds will be processed to the original payment method within 5-10 business days of receiving the returned item.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">5. Payment</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  We accept all major credit cards (Visa, Mastercard, American Express) through our secure payment processor, Stripe. All transactions are encrypted and secure.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">6. Limitation of Liability</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  In no case shall Shiva Shakti Garments, our directors, officers, employees, affiliates, agents, contractors, or suppliers be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-xl text-[#2C2420] mb-4">7. Contact Information</h2>
                <p className="text-[#5D5550] leading-relaxed">
                  Questions about the Terms of Service should be sent to us at{' '}
                  <a href="mailto:prabalbansal11@gmail.com" className="text-[#C6A87C] hover:underline">
                    prabalbansal11@gmail.com
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </div>
    </Layout>
  );
};
